<template>
    <div id="app">
        <transition name="fade"
                    mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {},
        created() {

        }
    }

</script>


<style lang="scss">
    /*@import '~material-icons/iconfont/material-icons.css';*/
    @import 'assets/vuetify.css';

    html, body {
        width: 100%;
        height: 100%;
        max-width: 414px;
        margin: 0px auto;
        padding: 0px;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        background: rgb(248,226,172);
    }

    #app {
        /*position: absolute;*/
        top: 0px;
        bottom: 0px;
        width: 100%;
        height: 100%;
        /*background: #eee;*/
    }

    .el-submenu [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .el-menu-item [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .toolbar {
        background: #f2f2f2;
        padding: 10px;
        //border:1px solid #dfe6ec;
        margin: 10px 0px;

        .el-form-item {
            margin-bottom: 10px;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all .2s ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }

    .t-op__container {
        display: flex;
        justify-content: space-between;
    }
</style>



// WEBPACK FOOTER //
// App.vue?0191548e